import { initializeTabs } from './tabManager';
import { fetchAndSetOptions } from './fetchAndSetOptions';
import { fetchTitleAutocompleteResults, debounce } from './fetchTitleAutocompleteResults';
import ContentService from 'grapesjs-preset-mautic/dist/content.service';

// Create a global window object which holds the information about GrapesJS plugins
window.MauticGrapesJsPlugins = window.MauticGrapesJsPlugins || [];

// Definition of the plugin.
const DrupalIntegratedContentBundle = (editor) => {
    // Constants for reusable values
    const COMPONENT_TYPE = 'drupal-integrated-content';
    const COMPONENT_CLASS = 'drupal-integrated-content';

    // Add a new block that opens a modal for content selection
    editor.BlockManager.add(`${COMPONENT_TYPE}-block`, {
        label: 'Drupal Integrated Content',
        media: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <g transform="translate(0 69.43) scale(1.2818)">
            <path d="M216.2,66.3c-0.1-0.2-0.2-0.3-0.4-0.5c-9.8-11-23.7-26.6-33.7-37.7c-3.1-3.3-6.2-6.6-9.1-10
              c-0.7-0.8-1.3-1.6-2-2.4c-0.6-0.6-0.9-1-0.9-1l0.1,0c-3.4-4-6.1-8.5-8-13.3l-0.5-1.1c0-0.1-0.1-0.1-0.2-0.2
              c-0.1-0.1-0.3-0.1-0.4-0.1H161c-0.2,0-0.3,0.1-0.4,0.1c-0.1,0.1-0.1,0.1-0.2,0.2l-0.5,1.1c-2,4.8-4.7,9.3-8,13.3l0.1,0
              c0,0-0.3,0.4-0.9,1c-0.7,0.8-1.3,1.6-2,2.4c-3,3.4-6,6.7-9.1,10c-9.9,11.1-23.9,26.7-33.7,37.7c-0.1,0.2-0.2,0.3-0.4,0.5
              c-37,49.3,3.2,89.5,3.2,89.5l-0.1,0c11.9,13.8,28.8,22.3,46.9,23.6c1.6,0.2,3.3,0.3,5.1,0.3h0.1c1.7,0,3.4-0.1,5.1-0.3
              c18.2-1.3,35-9.8,46.9-23.6l-0.1,0C213,155.8,253.2,115.6,216.2,66.3z M130.1,101l-0.9,1.4l-0.1,0.1c-6.8,8.2-10.8,17-12.1,25.7
              c-0.2,1.1-1.2,1.8-2.2,1.6c-0.7-0.1-1.2-0.6-1.5-1.2c-1.8-4.2-3-8.6-3.6-13.1c-2.2-15.9,2.6-29.8,12.8-41.7
              c4.1-4.7,8.2-9.4,12.3-14.1c0.7-0.8,1.9-0.9,2.7-0.2c0,0,0,0,0,0c0.1,0.1,0.1,0.1,0.2,0.2c3.3,3.8,7.6,8.7,12.4,14.3
              c0.6,0.7,0.6,1.8,0,2.6c-6.6,7.9-13.6,16.3-19.9,24.3L130.1,101z M186.9,142.2L186.9,142.2c-3.8,10-11.3,16-21.9,17.7
              c-15.1,2.3-29.2-8-31.5-23.1c0-0.2,0-0.3-0.1-0.5c-1.2-8.5,1.4-16,6.9-22.4c6.4-7.5,20.5-24.9,20.7-25.2h0
              c0.3,0.3,15.3,19,20.9,25.6C189.1,122.6,190.7,132.1,186.9,142.2z M209.3,126.5L209.3,126.5c-0.1,0.3-0.3,0.7-0.4,1
              c-0.4,1-1.5,1.5-2.5,1.1c-0.6-0.3-1.1-0.8-1.2-1.5c-1.4-8.4-5.4-16.8-11.9-24.7l-0.1-0.1l-0.6-0.9l-0.4-0.5
              c-5.2-6.6-32.7-38.8-44.7-52.8c-0.6-0.7-0.6-1.8,0-2.6c4-4.4,8-8.8,11.9-13.3c0.7-0.8,1.9-0.8,2.7-0.1c0,0,0.1,0.1,0.1,0.1
              c1.8,1.9,3.5,3.8,5.2,5.8c10.9,12.2,21.9,24.2,32.5,36.5C213.2,89.9,216.3,107.7,209.3,126.5z"/>
            <g>
              <path d="M318.9,189.8h12.5v2.5h-5v12.4h-2.5v-12.4h-5L318.9,189.8z"/>
              <path d="M347,204.7l-1.1-10.8l-0.7,3.6l-2.6,7.2h-3.2l-2.6-7.2l-0.7-3.6l-1.1,10.8h-2.6l1.5-14.9h2.8
                l4.3,11.9l4.3-11.9h2.8l1.5,14.9H347z"/>
              <path d="M28,193.7H0v73.2h28c20.2,0,36.6-16.4,36.6-36.6C64.6,210.1,48.2,193.8,28,193.7 M45.3,247.6
                c-4.6,4.6-10.8,7.2-17.3,7.1H12.2v-48.9H28c13.6,0.1,24.5,11.2,24.4,24.7C52.3,237,49.8,243.1,45.3,247.6 M301.5,267h12.2v-77.6
                h-12.2L301.5,267z M85.2,217.1v-4.5H73v54.4h12.2v-33.6c0-5.9,4.9-8.6,9.5-8.6h7.6v-12.2h-7.6C91,212.6,87.6,214.3,85.2,217.1
                M150.3,240.8c0.1,4.2-1.2,8.2-3.7,11.6c-2.5,3.1-6.3,4.8-10.3,4.7c-3.3,0.1-6.5-1.1-9-3.3c-2.6-2.5-3.9-6.2-3.9-11v-29.1h-12.2
                v31.9c-0.1,6.1,2.4,12,6.9,16.2c4.6,4.3,10.7,6.6,16.9,6.5c5.6,0.1,11.1-1.9,15.2-5.8v4.6h12.2v-53.4h-12.2L150.3,240.8z
                M201.5,212.3c-6.2,0-12.2,2.2-16.9,6.3v-5h-12.2v77.7h12.2v-29.2c4.7,4.1,10.7,6.3,16.9,6.3c15.1,0,27.3-12.5,27.3-27.9
                C228.8,224.8,216.5,212.3,201.5,212.3 M212.1,251.5c-2.8,2.9-6.6,4.6-10.6,4.6c-8.6-0.2-15.4-7.2-15.3-15.8
                c0-4.2,1.6-8.2,4.5-11.3c2.8-3,6.7-4.6,10.8-4.6c8.3,0,15.1,7.1,15.1,15.9C216.6,244.4,215,248.5,212.1,251.5 M278.7,218.6
                c-4.7-4.1-10.7-6.4-16.9-6.3c-15.1,0-27.3,12.5-27.3,27.9c0,15.4,12.2,28,27.3,28c6.2,0.1,12.3-2.2,16.9-6.3v5.1h12.2v-53.5h-12.2
                L278.7,218.6z M261.7,256.1c-8.4,0-15.2-7.1-15.2-15.9c0-8.7,6.8-15.8,15.2-15.8c8.4,0,15.2,7.1,15.2,15.8
                C276.9,248.9,270.1,256.1,261.7,256.1"/>
            </g>
          </g>
        </svg>`,
        category: 'Blocks',
        activate: true,
        content: {
            type: COMPONENT_TYPE,
            activeOnRender: true,
            class: COMPONENT_CLASS
        }
    });

    // Add a custom component type for the Drupal integrated content
    editor.DomComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (!el.getAttribute) return false;

            return (el.classList && el.classList.contains(COMPONENT_CLASS))
                ? { type: COMPONENT_TYPE }
                : false;
        },
        model: {
            defaults: {
                content: '{drupal_integrated_content: not configured}',
            },
            init() {
                // Add a custom edit button that opens the modal.
                const toolbar = this.get('toolbar');
                const id = `toolbar-${COMPONENT_CLASS}`;
                if (!toolbar.filter(tlb => tlb.id === id).length) {
                    toolbar.unshift({
                        id,
                        command: 'open-drupal-content-modal',
                        attributes: {
                            class: 'fa fa-pencil-square-o'
                        }
                    });
                }
            },
        },
        view: {
            // Open the modal on activation and double click.
            events: {
                dblclick: 'onActive'
            },
            onActive() {
                editor.runCommand('open-drupal-content-modal');
            }

        }
    });

    const contentModal = `
        <div id="drupal-content-modal" class="drupal-content-modal--inner" role="tablist">
            <ul class="nav nav-tabs pr-md pl-md drupal-content-tabs">
                <li><a href="#drupal-content-node" id="drupal-content-node-tab" role="tab" aria-controls="drupal-content-node" aria-selected="true" tabindex="0">Single Node</a></li>
                <li><a href="#drupal-content-view" id="drupal-content-view-tab" role="tab" aria-controls="drupal-content-view" aria-selected="false" tabindex="-1">View</a></li>
            </ul>
            <div class="drupal-content-tab-content">
                <div id="drupal-content-node" role="tabpanel" aria-labelledby="drupal-content-node-tab">
                    <div class="content-type-container form-container">
                        <label for="drupal-content-node-type">Content Type:</label>
                        <select id="drupal-content-node-type" required>
                        </select>
                    </div>
                    <div class="view-mode-container form-container">
                        <label for="drupal-content-node-view-mode">View Mode:</label>
                        <select id="drupal-content-node-view-mode" required>
                        </select>
                    </div>
                    <div class="node-autocomplete-container form-container">
                        <label for="drupal-content-node-title">Title:</label>
                        <input type="text" id="drupal-content-node-title" class="drupal-content-node-title-input" placeholder="Search for nodes by title" required>
                        <ul id="drupal-content-node-title-autocomplete" class="autocomplete-list"></ul>
                    </div>
                </div>
                <div id="drupal-content-view" role="tabpanel" aria-labelledby="drupal-content-view-tab" hidden>
                    <div class="view-display-container form-container">
                        <label for="drupal-content-view-display">View display:</label>
                        <select id="drupal-content-view-display" required>
                        </select>
                        <div class="form-description">Only displays of the "Mautic email content" type can be selected.</div>
                    </div>
                    <div class="view-arguments-container form-container">
                        <label for="drupal-content-view-args">Arguments:</label>
                        <input type="text" id="drupal-content-view-args" class="drupal-content-view-args-input" placeholder="arg1/{contactfield=alias|default}">
                        <div class="form-description">Enter arguments for the view like "arg1/arg2/...". Mautic tokens allowed (e.g. {contactfield=lastname|Guest})</div>
                    </div>
                </div>
                <div class="language-container form-container">
                    <label for="drupal-content-language">Language:</label>
                    <select id="drupal-content-language" required>
                    </select>
                </div>
            </div>
        </div>

        <div class="drupal-content-notes">
            <div class="drupal-content-note">The Drupal content will be cached for 5 minutes, this can temporarily cause stale content.</div>
        </div>

        <div class="drupal-content-buttons">
            <button id="drupal-content-submit" class="gjs-btn-prim">Submit</button>
            <button id="drupal-content-close" class="gjs-btn-prim">Close</button>
        </div>
    `;

    // Add a command to open the content selector modal
    editor.Commands.add('open-drupal-content-modal', {
        run(editor) {
            editor.Modal.open({
                title: 'Add content from Drupal',
                content: contentModal,
                attributes: {
                    class: 'drupal-content-modal'
                }
            });
            const selectedComponent = editor.getSelected();
            const attributes = selectedComponent?.get('attributes');
            const modal = editor.Modal.getContentEl().querySelector('#drupal-content-modal');
            const typeSelect = modal.querySelector('#drupal-content-node-type');
            const viewModeSelect = modal.querySelector('#drupal-content-node-view-mode');
            const titleInput = modal.querySelector('#drupal-content-node-title');
            const viewSelect = modal.querySelector('#drupal-content-view-display');
            const viewArgsInput = modal.querySelector('#drupal-content-view-args');
            const autocompleteList = modal.querySelector('#drupal-content-node-title-autocomplete');
            const languageSelect = modal.querySelector('#drupal-content-language');
            const submitButton = editor.Modal.getContentEl().querySelector('#drupal-content-submit');
            const closeButton = editor.Modal.getContentEl().querySelector('#drupal-content-close');

            // Initialise tabs.
            let activeTab = attributes?.drupalcontent === 'view' ? 'drupal-content-view-tab' : 'drupal-content-node-tab';
            initializeTabs(modal, activeTab);

            // Populate the inputs.
            fetchAndSetOptions('/drupal-content/api/types', typeSelect, attributes?.drupaltype);
            fetchAndSetOptions('/drupal-content/api/view_modes', viewModeSelect, attributes?.drupalviewmode);
            titleInput.value = attributes?.drupaltitle ? attributes?.drupaltitle : '';
            titleInput.setAttribute('node-nid', attributes?.drupalnode);
            fetchAndSetOptions('/drupal-content/api/views', viewSelect, attributes?.drupalview);
            viewArgsInput.value = attributes?.drupalargs ? decodeURIComponent(attributes?.drupalargs) : '';
            fetchAndSetOptions('/drupal-content/api/languages', languageSelect, attributes?.drupallang);

            // Initialise autocomplete.
            titleInput?.addEventListener('input', debounce(() => {
                const searchTerm = titleInput.value.trim();
                if (searchTerm.length > 2) {
                    fetchTitleAutocompleteResults(titleInput, autocompleteList, typeSelect.value);
                } else {
                    autocompleteList.innerHTML = '';
                }
            }, 300));
            titleInput?.addEventListener('blur', () => {
                setTimeout(() => {
                    autocompleteList.innerHTML = '';
                }, 200);
            });

            // Add submit event listener to process data collected from the open modal.
            submitButton?.addEventListener('click', () => {
                // Fetch the settings.
                const activeTab = modal.querySelector('.nav-tabs .active');
                if (!activeTab) return;
                const activeTabId = activeTab.getAttribute('href')?.substring(1);
                const selectedComponent = editor.getSelected();

                // We URL encode the args to prevent PHP parsing issues with spaces or commas.
                const encodedArgs = viewArgsInput?.value ? encodeURIComponent(viewArgsInput.value) : '';

                const metaData = {
                    type: activeTabId === 'drupal-content-view' ? 'view' : 'single_node',
                    contentType: typeSelect?.value,
                    node: titleInput?.getAttribute('node-nid'),
                    title: titleInput?.value,
                    viewMode: viewModeSelect?.value,
                    view: viewSelect?.value,
                    args: encodedArgs,
                    language: languageSelect?.value
                };

                // Update the component attributes and content.
                selectedComponent.addAttributes({
                    drupalcontent: metaData.type,
                    drupaltype: metaData.contentType,
                    drupalnode: metaData.node,
                    drupaltitle: metaData.title,
                    drupalviewmode: metaData.viewMode,
                    drupalview: metaData.view,
                    drupalargs: metaData.args,
                    drupallang: metaData.language
                });
                selectedComponent.set('tagName', ContentService.isMjmlMode(editor) ? 'mj-text' : 'div');
                const contentKeys = metaData.type === 'single_node'
                    ? ['type', 'contentType', 'node', 'title', 'viewMode', 'language']
                    : ['type', 'view', 'args', 'language'];
                const contentParams = contentKeys.filter(key => metaData[key])
                    .map(key => {
                      // Double safety for other fields, though args is already encoded above.
                      // Using encodeURIComponent protects against commas and spaces breaking parse_str.
                      if (key === 'args') return `args=${metaData.args}`;
                      return `${key}=${encodeURIComponent(metaData[key])}`;
                    })
                    .join(', ');

                const componentContent = `{drupal_integrated_content: ${contentParams}}`;
                if (selectedComponent.components().length === 0) {
                    selectedComponent.set('content', componentContent);
                } else {
                    selectedComponent.components().reset(componentContent);
                }

                // For the Builder display, specifically for the MJML builder display.
                if (selectedComponent) {
                    selectedComponent.setStyle({
                        'padding-top': '10px',
                        'padding-bottom': '10px',
                        'padding-right': '25px',
                        'padding-left': '25px',
                        'font-size': '13px',
                        'line-height': '22px',
                        'text-align': 'left',
                        'display': 'block'
                    });
                }
                selectedComponent.setClass(COMPONENT_CLASS);

                editor.Modal.close();
            });
            closeButton?.addEventListener('click', () => {
                editor.Modal.close();
            });
        }
    });
};

window.MauticGrapesJsPlugins.push({
    name: 'DrupalIntegratedContentBundle',
    plugin: DrupalIntegratedContentBundle,
    context: ['page', 'email-mjml', 'email-html']
});

export default DrupalIntegratedContentBundle;
